import { graph } from "config/axios-context";

export async function deleteMutation(mutationName: string, id: number | string) {
    try {
        const response = await graph<any, any>({
            query: `
                mutation {
                    ${mutationName}(id: ${id})
                }
            `,
            variables: {
                id
            }
        });

        if (response.errors) {
            throw response.errors;
        }

        return response.data;
    } catch (error) {
        console.error(`Error executing mutation ${mutationName} with id ${id}:`, error);
        throw error; // Re-throw the error to be handled by the caller
    }
} 
